import { Container } from "pixi.js";
import type { SlotApp } from "../app/createSlotApp";
import { DesignSpaceRoot } from "@slot/presentation";

/**
 * Stage layers in DESIGN UNITS under the `DesignSpaceRoot` (fit-height), in scene order: the game,
 * the slam surface, the game's modal panels.
 *
 * The header and the boot loader had layers of their own until their views became DOM (step 8b and
 * decision 19); both containers were left behind rendering nothing, and are gone.
 */
export interface StageLayers {
  world: DesignSpaceRoot;
  game: Container;
  controls: Container;
  modals: Container;
  /** A title's intro while it shows (decision 77), over everything else in the canvas. */
  intro: Container;
}

export function createStage(slot: SlotApp): StageLayers {
  const world = new DesignSpaceRoot(slot.viewport);
  const layers: StageLayers = {
    world,
    game: new Container({ label: "GameLayer" }),
    controls: new Container({ label: "ControlLayer" }),
    modals: new Container({ label: "ModalLayer" }),
    intro: new Container({ label: "IntroLayer" }),
  };
  world.addChild(layers.game, layers.controls, layers.modals, layers.intro);
  slot.app.stage.addChild(world);
  return layers;
}
